<template>
    <div class="w-100">
        <div class="space-between">
            <div class="primary--text" style="display: flex">
                <div><i class="mr-2" :class="icon"></i>{{ customer ? customer.name : sites[0].customer.name }}</div>
                <div style="margin-left: 5px">
                    <v-dropdown-button v-if="false" v-model="expand" style="margin-bottom: 5px"/>
                </div>
            </div>
            <div style="font-size: 10pt; width: 150px; text-align: right">{{ timeAsString }}</div>

        </div>

        <div class="headline" v-if="sites">
            <div class="primary--text" style="font-size: 10pt; margin-top: -8px"> {{ sites[0].fabricNo }} - {{ sites[0].location }}</div>
        </div>

      <div class="headline" v-if="!sites">
        <div class="primary--text" style="font-size: 9pt; margin-top: -8px">konnte nicht ermittelt werden</div>
      </div>
    </div>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import VDropdownButton from "@/modules/core/components/utils/VDropdownButton";

export default {
    name: "MenuSiteCard",
    components: {
        VDropdownButton
    },
    props:  ["customer", "sites", "time", "icon"],

    data: () => ({
        expand: false
    }),

    watch: {
        expand () {
            this.$emit("expand", this.expand);
        }
    },

    computed: {
        timeAsString() {
            return Core.format.datetime.display(this.time);
        },
    }
}
</script>

<style scoped>

</style>